import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { Member } from './Member.js';
export class RegistrationWithEncryptedMember extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.registeredAt = null;
        this.deactivatedAt = null;
        this.waitingList = false;
        this.canRegister = false;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], RegistrationWithEncryptedMember.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], RegistrationWithEncryptedMember.prototype, "groupId", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], RegistrationWithEncryptedMember.prototype, "cycle", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], RegistrationWithEncryptedMember.prototype, "registeredAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], RegistrationWithEncryptedMember.prototype, "deactivatedAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], RegistrationWithEncryptedMember.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], RegistrationWithEncryptedMember.prototype, "updatedAt", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 16 })
], RegistrationWithEncryptedMember.prototype, "waitingList", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 20 })
], RegistrationWithEncryptedMember.prototype, "canRegister", void 0);
__decorate([
    field({ decoder: Member })
], RegistrationWithEncryptedMember.prototype, "member", void 0);
//# sourceMappingURL=RegistrationWithEncryptedMember.js.map